import React from 'react';
import LeavePolicyGenericWithAllotmentStep from '@/components/attendance/admin/wizard/shared/LeavePolicyGenericWithAllotmentStep';
import { WizardStepProps } from '@/components/attendance/admin/wizard/useLeavePoliciesWizard';

export default function LeavePolicySickStep01(props: WizardStepProps) {
  return <LeavePolicyGenericWithAllotmentStep type="sick" {...props} />;
}
